"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var auth0_react_1 = require("@auth0/auth0-react");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var pages_1 = require("../../hooks/pages");
var hooks_1 = require("../../hooks");
var hooks_2 = require("../../modules/categories/hooks");
var actions_1 = require("../../modules/stations/actions");
var hooks_3 = require("../../modules/sections/hooks");
var SectionText_1 = __importDefault(require("../sections/SectionText"));
var CategoryText_1 = __importDefault(require("../categories/CategoryText"));
var hooks_4 = require("../../modules/stations/hooks");
var utils_1 = require("../../utils");
var StationQR_1 = __importDefault(require("./StationQR"));
var styles = {
    qrModal: { top: 36 },
};
var StationListView = react_1.default.memo(function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, hooks_1.useAppDispatch)();
    var getAccessTokenSilently = (0, auth0_react_1.useAuth0)().getAccessTokenSilently;
    var _a = (0, hooks_4.useStations)(), stations = _a.items, stationsInitialFetch = _a.initialFetchDone, stationsFetching = _a.isFetching;
    var _b = (0, hooks_3.useSections)(), sections = _b.items, sectionsByID = _b.itemsByID;
    var categories = (0, hooks_2.useCategories)().items;
    var _c = (0, react_1.useState)(null), qrStation = _c[0], setQrStation = _c[1];
    var _d = (0, react_1.useState)(null), delStation = _d[0], setDelStation = _d[1];
    var columns = (0, react_1.useMemo)(function () { return [
        {
            title: "Title",
            dataIndex: "title",
        },
        {
            title: "Section",
            dataIndex: "section",
            filters: sections.map(function (s) { return ({ text: s.title, value: s.id }); }),
            onFilter: function (value, record) { return record.section === value; },
            render: function (section) { return react_1.default.createElement(SectionText_1.default, { id: section }); },
        },
        {
            title: "Category",
            dataIndex: "category",
            filters: categories.map(function (_a) {
                var c = _a.id;
                return ({ text: c, value: c });
            }),
            onFilter: function (value, record) { return record.category === value; },
            render: function (category, _a) {
                var _b;
                var section = _a.section;
                return react_1.default.createElement(CategoryText_1.default, { id: category, color: (_b = sectionsByID[section]) === null || _b === void 0 ? void 0 : _b.color });
            },
        },
        {
            title: "Visible",
            render: function (station) {
                return (station.visible.from && station.visible.to)
                    ? "".concat(station.visible.from, " to ").concat(station.visible.to)
                    : (station.enabled ? "Yes" : "No");
            },
        },
        {
            title: "Last Modified",
            sorter: function (a, b) {
                return (new Date(a.revision.timestamp)).getTime() - (new Date(b.revision.timestamp)).getTime();
            },
            render: function (station) { return (0, utils_1.timestampToString)(station.revision.timestamp); },
        },
        {
            title: "Actions",
            key: "actions",
            render: function (station) { return (react_1.default.createElement(antd_1.Space, { size: "small" },
                react_1.default.createElement(antd_1.Tooltip, { title: "Show QR Code" },
                    react_1.default.createElement(antd_1.Button, { icon: react_1.default.createElement(icons_1.QrcodeOutlined, null), onClick: function () { return setQrStation(station); } })),
                react_1.default.createElement(antd_1.Button, { icon: react_1.default.createElement(icons_1.EyeOutlined, null), onClick: function () { return navigate("../detail/".concat(station.id)); } }, "View"),
                react_1.default.createElement(antd_1.Button, { icon: react_1.default.createElement(icons_1.EditOutlined, null), onClick: function () { return navigate("../edit/".concat(station.id)); } }, "Edit"),
                react_1.default.createElement(antd_1.Button, { icon: react_1.default.createElement(icons_1.DeleteOutlined, null), danger: true, onClick: function () { return setDelStation(station); } }, "Delete"))); },
        },
    ]; }, [navigate, sections, categories]);
    var onAdd = (0, react_1.useCallback)(function () { return navigate("../add"); }, [navigate]);
    var extra = (0, react_1.useMemo)(function () { return [
        react_1.default.createElement(antd_1.Button, { key: "add", type: "primary", icon: react_1.default.createElement(icons_1.PlusOutlined, null), onClick: onAdd }, "Add New"),
    ]; }, [onAdd]);
    var closeQrModal = (0, react_1.useCallback)(function () { return setQrStation(null); }, []);
    var closeDelModal = (0, react_1.useCallback)(function () { return setDelStation(null); }, []);
    var onDisable = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!delStation)
                        return [2 /*return*/];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, getAccessTokenSilently(utils_1.ACCESS_TOKEN_MANAGE)];
                case 2:
                    token = _c.sent();
                    return [4 /*yield*/, dispatch((0, actions_1.updateStation)(delStation.id, {
                            enabled: false,
                            revision: {
                                working_copy: (_b = (_a = delStation.revision) === null || _a === void 0 ? void 0 : _a.number) !== null && _b !== void 0 ? _b : null,
                            },
                        }, token))];
                case 3:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _c.sent();
                    console.error(e_1);
                    return [3 /*break*/, 5];
                case 5:
                    closeDelModal();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, getAccessTokenSilently, delStation]);
    var onDelete = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var token, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!delStation)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, getAccessTokenSilently(utils_1.ACCESS_TOKEN_MANAGE)];
                case 2:
                    token = _a.sent();
                    return [4 /*yield*/, dispatch((0, actions_1.deleteStation)(delStation.id, token))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_2 = _a.sent();
                    console.error(e_2);
                    return [3 /*break*/, 5];
                case 5:
                    closeDelModal();
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, getAccessTokenSilently, delStation]);
    var pagination = (0, pages_1.useUrlPagination)();
    return react_1.default.createElement(antd_1.PageHeader, { ghost: false, title: "Stations", subTitle: "Edit and create app stations", extra: extra },
        react_1.default.createElement(antd_1.Modal, { title: qrStation === null || qrStation === void 0 ? void 0 : qrStation.title, style: styles.qrModal, open: !!qrStation, onCancel: closeQrModal, footer: null }, qrStation ? react_1.default.createElement(StationQR_1.default, { station: qrStation }) : null),
        react_1.default.createElement(antd_1.Modal, { title: "Delete station: ".concat(delStation === null || delStation === void 0 ? void 0 : delStation.title), open: !!delStation, onCancel: closeDelModal, footer: react_1.default.createElement(antd_1.Space, null,
                react_1.default.createElement(antd_1.Button, { type: "primary", danger: true, icon: react_1.default.createElement(icons_1.DeleteOutlined, null), onClick: onDelete }, "Delete"),
                (delStation === null || delStation === void 0 ? void 0 : delStation.enabled)
                    ? react_1.default.createElement(antd_1.Button, { type: "primary", icon: react_1.default.createElement(icons_1.CloseSquareOutlined, null), onClick: onDisable }, "Disable")
                    : null,
                react_1.default.createElement(antd_1.Button, { onClick: closeDelModal }, "Cancel")) },
            "Are you sure you wish to delete the station \u201C", delStation === null || delStation === void 0 ? void 0 :
            delStation.title,
            "\u201D? If other content refers to this station, those links will be ",
            react_1.default.createElement("strong", null, "broken"),
            ".\u00A0",
            (delStation === null || delStation === void 0 ? void 0 : delStation.enabled) ? react_1.default.createElement("span", null,
                "If you wish, you can instead ",
                react_1.default.createElement("a", { href: "#", onClick: onDisable }, "disable"),
                " this station.") : ""),
        react_1.default.createElement(antd_1.Table, { bordered: true, size: "small", loading: !stationsInitialFetch && stationsFetching, columns: columns, rowKey: "id", dataSource: stations, pagination: pagination }));
});
exports.default = StationListView;
